import request from '@/utils/request'

export function fetchAllVideoList(data) {
  return request({
    url: '/v1/video-fe/list',
    method: 'get',
    params: data
  })
}

export function fetchVideoCate(data) {
  return request({
    url: '/v1/video-fe/category-list',
    method: 'get',
    params: data
  })
}

export function fetchHotVideoList(data) {
  return request({
    url: '/v1/video-fe/hot-list',
    method: 'get',
    params: data
  })
}

export function fetchRecommendVideoList(data) {
  return request({
    url: '/v1/video-fe/promotion-list',
    method: 'get',
    params: data
  })
}

export function fetchVideoDetail(data) {
  return request({
    url: '/v1/video-fe/get-video',
    method: 'get',
    params: data
  })
}

export function fetchVideoHits(data) {
  return request({
    url: '/v1/video-fe/hits',
    method: 'get',
    params: data
  })
}

export function fetchHistoryVideo(data) {
  return request({
    url: '/v1/video/view-list',
    method: 'get',
    params: data
  })
}

export function fetchVideoByKeys(data) {
  return request({
    url: '/v1/video/list',
    method: 'get',
    params: data
  })
}

export function fetchVideoSetInfo(data) {
  return request({
    url: '/v1/video/record/detail',
    method: 'get',
    params: data
  })
}

export function setVideoSet(data) {
  return request({
    url: '/v1/video/record/publish',
    method: 'post',
    data
  })
}

export function inputInfo(data) {
  return request({
    url: '/v1/video/record/sence-files',
    method: 'post',
    data
  })
}
